<nav class="navbar dashboard-nav">
  <div class="top-title-and-btns">
    <div class="dashboard-title" *ngIf="!loading">
      <a [routerLink]="['/']" title="Go to District Profile" class="logo">
        <img
          src="../assets/images/{{
            isStarterUser
              ? 'renaissance_analytics.svg'
              : 'schoolzilla_logo.png'
          }}"
          class="sz-image"
          alt="Schoolzilla logo"
        />
      </a>
      <navbar-announcement
        [hasFrozenEnrollment]="hasFrozenEnrollment"
        [isStarter]="isStarterUser"
        class="navbar-announcement"
      ></navbar-announcement>
    </div>
    <div class="top-nav-btns">
      <top-nav-btns
        *ngIf="!isMobile"
        [topNavBtns]="topNavBtns"
        [isAdmin]="isAdmin"
        [isRestrictedUser]="isRestrictedUser"
        [hasDataWall]="hasDataWall"
        [currentPage]="currentPage"
        [rgpTenantId]="rgpTenantId"
        class="all-btns"
      ></top-nav-btns>
      <navbar-hamburger
        *ngIf="isMobile"
        [isAdmin]="isAdmin"
        [isRestrictedUser]="isRestrictedUser"
        [hasDataWall]="hasDataWall"
        [hostname]="hostname"
        [dropdownItems]="hamburgerDropdownItems"
        [rgpTenantId]="rgpTenantId"
      ></navbar-hamburger>
    </div>
  </div>
  <ul class="nav navbar-nav dashboard-nav-links">
    <li
      data-id="Nav.DistrictProfile"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ exact: true }"
      [ngClass]="{ 'col-md-offset-1': !isAdmin && !isSchoolLeader }"
      class="col-md-2 col-sm-12"
    >
      <a [routerLink]="['/']"> District Profile </a>
    </li>
    <li
      *ngIf="showOurSchoolsNavLink"
      data-id="Nav.OurSchools"
      [routerLinkActive]="['active']"
      class="col-md-2 col-sm-12"
    >
      <a [routerLink]="['/comparison/school']"> Our Schools </a>
    </li>
    <li
      data-id="Nav.SchoolProfile"
      [routerLinkActive]="['active']"
      *ngIf="!isRestrictedUser"
      class="col-md-2 col-sm-12"
    >
      <a [routerLink]="['/profile/school']"> School Profile </a>
    </li>
    <li
      data-id="Nav.OurStudents"
      [routerLinkActive]="['active']"
      *ngIf="!isRestrictedUser"
      class="col-md-2 col-sm-12"
    >
      <a [routerLink]="['/comparison/student']"> Our Students </a>
    </li>
    <li
      data-id="Nav.StudentProfile"
      [routerLinkActive]="['active']"
      *ngIf="!isRestrictedUser"
      class="col-md-2 col-sm-12"
    >
      <a [routerLink]="['/profile/student']"> Student Profile </a>
    </li>
    <li *ngIf="(isAdmin || isSchoolLeader) && !isStarterUser" class="pipe-li">
      <span class="pipe">|</span>
    </li>
    <li
      data-id="Nav.UsageProfile"
      [routerLinkActive]="['active']"
      *ngIf="(isAdmin || isSchoolLeader) && !isStarterUser"
      class="col-md-2 col-sm-12 usage-li"
    >
      <a [routerLink]="['/usage']"> Usage Profile </a>
    </li>
  </ul>
</nav>
<div
  *ngIf="kpiService.errorMessage && !isStarterUser"
  class="alert alert-danger"
  role="alert"
  [innerHTML]="kpiService.errorMessage"
></div>
<div
  *ngIf="kpiService.errorMessage && isStarterUser"
  class="alert alert-danger"
  role="alert"
>
  {{ kpiService.errorMessage }} access
  <live-chat
    data-cy="NavLiveChat"
    [rgpTenantId]="rgpTenantId"
    class="live-chat"
  ></live-chat>
  if you think this is an error or the issue persists.
</div>
